// A Route's display name is the route record's own name — decoupled from the
// name of the Connection that provides its data. Older Routes may have no
// route record (default_route: null with an empty routing_rules), so fall
// back to the provider's name rather than rendering blank.
export const routeDisplayName = (route: any): string =>
  route?.default_route?.name ||
  route?.routing_rules?.[0]?.name ||
  route?.provider?.name ||
  '';

// A Route's own record id — what /v2/routes/ addresses, and what every WRITE
// (rename, destinations, configuration) must target. NOT what a /routes/... URL
// carries: those carry the PROVIDER INTEGRATION id, and the page resolves this
// record from it. The two are different id spaces, so a record id sent to
// /v2/integrations/ or /v2/connections/ finds nothing, and vice versa.
//
// Older connections can report `default_route: null` while still carrying the
// record in `routing_rules` (seen on stage), so both are checked. Returns
// undefined when the connection has no record at all — a URL builder should
// treat that as "no Route page exists", and an API caller must not substitute
// the integration id to fill the gap.
export const routeRecordId = (route: any): string | undefined =>
  route?.default_route?.id || route?.routing_rules?.[0]?.id || undefined;
